import { CategoryType, ThematicType } from './Enums';

export class CategoryModel {

    public constructor(init?: Partial<Pick<CategoryModel, keyof CategoryModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    name = '';
    description: string;
    type: CategoryType;
    isActive = false;
    ordinal = 0;

    createdAt: Date;
    updatedAt?: Date;

    logoURL: string;
}


export class ThematicModel {

    public constructor(init?: Partial<Pick<ThematicModel, keyof ThematicModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    parentId: number;
    name = '';
    description: string;
    logoURL: string;
    iconURL: string;

    type = ThematicType.Main;
    isActive = false;
    ordinal = 0;

    createdAt: Date;
    updatedAt?: Date;
}


export class ZoneModel {

    public constructor(init?: Partial<Pick<ZoneModel, keyof ZoneModel>>) {

        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            Object.assign(this, init);
        }
    }

    id: number;
    
    name: string;
    description: string;
    
    isActive = false;
    coordinates: string;

    color: string;

    createdAt: Date;
    updatedAt?: Date;
}
